import { useEffect, useRef, useState, Fragment } from 'react';
import { Drawer, message, Popconfirm } from 'antd';
import { config } from './config';
import AddOrEditForm from './addOrEdit';
import { getActivityProductSkuDetailList, deleteActivityProductSkuDetail } from '@/services/product';
import {
  SActionBtn,
  SLowcodeList,
  STableActions,
  SMessage,
} from 'shj-components'

const MaterialDetail = (props: any) => {
  const { show, setVisible, pid, psid } = props;

  const listRef = useRef<any>();
  const [visibleEdit, setVisibleEdit] = useState(false);
  const [editData, setEditData] = useState({});
  const [id, setId] = useState(0);

  const fetchList = (values: any) => {
    return new Promise(async (resolve, reject) => {
      try {
        const { current, pageSize, ...rest } = values;
        const where = { activityProductId: pid };

        getList(where, [current, pageSize], function (records, total) {
          resolve({ records, total });
        });
      } catch (e) {
        console.log(e);
        reject({ success: false });
      }
    });
  };

  const getList = async (data = {}, pages = [1, 10], backFn = (a, b) => ({})) => {
    try {
      const res: any = await getActivityProductSkuDetailList({
        params: {
          pageId: pages[0],
          pageSize: pages[1],
        },
        data,
      });
      const records = res?.list;
      const all = res?.count;
      backFn(records, all);
    } catch (err) {
      console.log(err);
    }
  };
  const onAdd = () => {
    setId(0);
    setVisibleEdit(true);
    setEditData({});
  };

  const closeModal = () => {
    setVisible(false);
  };
  const onDelete = async (record: any) => {
    SMessage.delete({
      onOk: async () => {
        try {
          const res: any = await deleteActivityProductSkuDetail(record.id);
          if (res.errorCode === 0) {
            message.success(res.message || '删除成功');
            (listRef as any)?.current?.reload();
          } else {
            message.error('删除失败');
          }
        } catch (err) {
          console.log(err)
        }
      },
      onCancel: () => {
        message.warning('取消删除');
      },
    });
  };

  const extension = {
    request: { fetchList },
    events: { onAdd },
    customRender: {
      editCell(text: any, record: object) {
        return (
          <Fragment>
            <STableActions>
              <SActionBtn danger onClick={() => onDelete(record)}>删除</SActionBtn>
            </STableActions>
          </Fragment>
        );
      },
    },
  };

  return (
    <Drawer
      title={'产品明细'}
      width={1000}
      onClose={closeModal}
      bodyStyle={{ padding: 15 }}
      visible={show}
      destroyOnClose={true}
    >
      <SLowcodeList searchMode="group" config={config} ref={listRef} {...extension} />
      <AddOrEditForm
        editData={editData}
        setVisible={setVisibleEdit}
        show={visibleEdit}
        id={id}
        pid={pid}
        psid={psid}
        listRef={listRef}
      />
    </Drawer>
  );
};
export default MaterialDetail;
